import React from "react";
import bg1 from "../assets/images/Banner_imgs/aboutus.jpg";
import about from "../assets/images/aboutus.jpg";
import about2 from "../assets/images/aboutus2.png";
import about3 from "../assets/images/aboutus3.jpeg";
import about4 from "../assets/images/aboutus4.png";
import PageContainer from "../components/container/Container";
import { FiArrowRight, FiCheck } from "../assets/icons/vander";

export default function AboutUs() {
  return (
    <PageContainer
      title={"About Us - CodeElan Technologies"}
      description={
        "Learn about CodeElan's mission, vision, and commitment to AI-driven digital transformation and innovative technology solutions."
      }
    >
      {/* Hero Section */}
      <section className="hero-section contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div className="hero-content">
                  <div className="hero-accent"></div>
                  <h1 className="hero-title">
                    About <span className="text-primary">CodeElan</span>
                  </h1>
                  <p className="hero-subtitle">
                    Empowering businesses through innovative technology solutions that drive digital transformation
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="about-content">
                <h2 className="section-title">Mission Statement</h2>
                <p className="section-subtitle">
                  At CodeElan, we aim to empower businesses through innovative
                  technology solutions that solve complex problems and drive
                  digital transformation. By adopting an "Adopt-Build-Operate"
                  approach, we deliver exceptional, scalable, and secure
                  solutions tailored to each client's unique journey.
                </p>
                <p className="section-subtitle">
                  Our expertise in AI, computer vision, and automation enables us to
                  create intelligent systems that enhance decision-making,
                  optimize operations, and unlock new possibilities. Our
                  commitment to excellence and continuous learning allows us to
                  lead with agility, ensuring success for our clients in an
                  ever-evolving technological landscape.
                </p>
                
                <h2 className="section-title mt-5">Vision</h2>
                <p className="section-subtitle">
                  To be a global leader in AI-driven digital transformation,
                  empowering businesses with cutting-edge technology solutions
                  that enhance efficiency, scalability, and innovation. Through
                  our innovative platforms, we strive to seamlessly
                  integrate AI, computer vision, automation, and cloud
                  technologies, enabling enterprises to navigate the future with
                  confidence.
                </p>
                <p className="section-subtitle">
                  Our vision is to transform industries, drive
                  sustainable growth, and foster a culture of continuous
                  learning and excellence, ensuring our clients remain ahead in
                  an ever-evolving technological landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="about-image-grid">
                <div className="image-row">
                  <div className="image-item">
                    <img src={about} className="img-fluid rounded-lg shadow-lg" alt="About CodeElan 1" />
                  </div>
                  <div className="image-item">
                    <img src={about4} className="img-fluid rounded-lg shadow-lg" alt="About CodeElan 2" />
                  </div>
                </div>
                <div className="image-row">
                  <div className="image-item">
                    <img src={about3} className="img-fluid rounded-lg shadow-lg" alt="About CodeElan 3" />
                  </div>
                  <div className="image-item">
                    <img src={about2} className="img-fluid rounded-lg shadow-lg" alt="About CodeElan 4" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="section-title">Our Core Values</h2>
              <p className="section-subtitle">
                The principles that guide our approach to technology and client relationships
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="value-card">
                <div className="value-icon">
                  <i className="mdi mdi-lightbulb-on"></i>
                </div>
                <h4 className="value-title">Innovation</h4>
                <p className="value-description">
                  Continuously pushing boundaries with cutting-edge AI and automation solutions
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="value-card">
                <div className="value-icon">
                  <i className="mdi mdi-handshake"></i>
                </div>
                <h4 className="value-title">Excellence</h4>
                <p className="value-description">
                  Delivering exceptional quality and results that exceed client expectations
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="value-card">
                <div className="value-icon">
                  <i className="mdi mdi-account-group"></i>
                </div>
                <h4 className="value-title">Collaboration</h4>
                <p className="value-description">
                  Working closely with clients to understand and solve their unique challenges
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
}
